<template>
    <section class="bg-blue-light pad-y-60 text-center">
      <div class="container">
        <div class="heading" data-aos="fade-down">
          <h2 class="title font-secondary fs-40 text-teal-dark">Om Swastyastu</h2>
        </div>

        <p class="font-weight-lighter font-italic mar-bottom-25" data-aos="fade-right" data-aos-delay="300">
          Atas Asung Kertha Wara Nugraha Ida Sang Hyang Widhi  Wasa / Tuhan Yang Maha Esa, kami bermaksud mengundang Bapak/Ibu/Saudara/i, pada acara Pawiwahan (Pernikahan) & Mepandes putra-putri kami pada :
        </p>

        <div class="row py-3">
          <div class="col-lg-6">
            <Event 
              :location="{
                map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1117.251058233721!2d115.17194385850627!3d-8.71854936038816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDMnMDcuMiJTIDExNcKwMTAnMjEuMCJF!5e0!3m2!1sen!2sid!4v1604503044196!5m2!1sen!2sid',
                address: 'Jalan Poppies I, Gang Sorga, Lingkungan Pengabetan, Depan Hotel Suji Bungalow, Kuta, Badung - Bali',
                direction: 'https://www.google.com/maps/dir//-8.718667,115.172511/@-8.718667,115.1703223,17z/data=!4m2!4m1!3e0',
              }"
              start="2020-11-18 12:00"
              end="18:00"
              title="Pawiwahan dan Mepandes"
              data-aos="fade-right" data-aos-delay="300"
            />
          </div>
          <div class="col-lg-6">
            <Event 
              :location="{
                map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.5811352577143!2d115.16993231478453!3d-8.731262993727734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0!2zOMKwNDMnNTIuNiJTIDExNcKwMTAnMTkuNiJF!5e0!3m2!1sen!2sid!4v1604537583070!5m2!1sen!2sid',
                address: 'Jalan Kubu Anyar No. 58 Kuta, Badung - Bali',
                direction: 'https://www.google.com/maps/dir//-8.731263,115.172121/@-8.731263,115.1699323,17z/data=!4m2!4m1!3e0',
              }"
              start="2020-11-27 12:00"
              end="18:00"
              title="Resepsi"
              data-aos="fade-left" data-aos-delay="300"
            />
          </div>
        </div>

        <p class="font-weight-lighter font-italic" data-aos="fade-left" data-aos-delay="600">
          Merupakan suatu kehormatan dan kebahagiaan bagi kami apabila Bapak/Ibu/Saudara/i berkenan hadir dan memberikan doa restu kepada putra-putri kami. Atas kehadiran serta doa restu Bapak/Ibu/Saudara/i, kami sekeluarga mengucapkan terima kasih.
        </p>


        <!-- <p class="font-weight-lighter font-italic py-3 font-weight-bold" data-aos="fade-left" data-aos-delay="600">
          Mohon datang sesuai dengan waktu yang ditentukan dan tetap menjaga protokol kesehatan sesuai anjuran pemerintah seperti (memakai masker, menjaga jarak dan mencuci tangan) mengingat situasi dan kondisi pada masa Pandemi Covid-19. Semoga semua dalam keadaan sehat
        </p> -->


        <p class="font-weight-lighter font-italic mar-top-25" data-aos="fade-left" data-aos-delay="600">
          Kami yang berbahagia
        </p>

        <h3 data-aos="fade-up" data-aos-delay="650" class=" mb-0 aos-init aos-animate" style="
            font-size: 1rem;
            font-style: italic;
        ">Jro Mangku I Nyoman Kandia & I Wayan Budhi</h3>
        <h3 class="font-secondary text-teal-dark mb-0" data-aos="fade-up" data-aos-delay="700">{{ $parent.wedding.man.surname }} & {{ $parent.wedding.woman.surname }}</h3>
      </div>
    </section>
</template>

<script>
import Event from './Event';
export default {
  components: {
    Event
  }
}
</script>
